const baseURL = 'https://market.mirabyte.com.ar/';

export default baseURL;
